import React from 'react';

function Dashboard(props) {
    return (
        <div></div>
    );
}

export default Dashboard;